/* unplugin-vue-components disabled */import script from "./Qyxq.vue?vue&type=script&lang=ts&setup=true"
export * from "./Qyxq.vue?vue&type=script&lang=ts&setup=true"

import "./Qyxq.vue?vue&type=style&index=0&id=c34e80b8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c34e80b8"]])

export default __exports__